"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDueAt = void 0;
function calculateDueAt(requiredTime = 0, prepTime = 0, deliveryTime = 0, placedTime = 0) {
    const estimatedTime = placedTime + prepTime * 60 * 1000 + deliveryTime * 60 * 1000;
    return Math.max(estimatedTime, requiredTime);
}
exports.calculateDueAt = calculateDueAt;
//# sourceMappingURL=computeOrderArrival.js.map